import { MigrationManifest } from "redux-persist";

const migrations: MigrationManifest = {
  // 0: (state: PersistedState) => {
  //   return {};
  // }
};

export default migrations;
